import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryOptions
} from 'react-query'

import Api from 'src/services/Api'

export const authConfig = {
  sessions: {
    key: 'auth/sessions',
    request: async () => {
      const resp = await Api.getSessions()

      return resp.data
    }
  },
  allSessions: {
    key: 'auth/sessions/all',
    request: async () => {
      const resp = await Api.getAllSessions()

      return resp.data
    }
  }
}

interface UseGetSessions {
  options?: UseQueryOptions<Session[]>
}

export const useGetSessions = (props?: UseGetSessions) => {
  const { options } = props || {}
  const { sessions: config } = authConfig

  const state = useQuery<Session[]>(config.key, config.request, {
    ...options
  })

  return state
}

export const useGetAllSessions = (props?: UseGetSessions) => {
  const { options } = props || {}
  const { allSessions: config } = authConfig

  const state = useQuery<Session[]>(config.key, config.request, {
    ...options
  })

  return state
}

export const PATS_QUERY_KEY = 'auth/pat'

export const useGetPats = (options?: UseQueryOptions<PersonalAccessToken[]>) =>
  useQuery<PersonalAccessToken[]>(
    PATS_QUERY_KEY,
    async () => (await Api.getPats()).data,
    options
  )

export const useCreatePat = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (payload: CreatePatPayload) => Api.createPat(payload).then((r) => r.data),
    { onSuccess: () => queryClient.invalidateQueries(PATS_QUERY_KEY) }
  )
}

export const useRevokePat = () => {
  const queryClient = useQueryClient()

  return useMutation((id: string) => Api.revokePat(id), {
    onSuccess: () => queryClient.invalidateQueries(PATS_QUERY_KEY)
  })
}
